import { render, staticRenderFns } from "./WorkCalendarEditDialog.vue?vue&type=template&id=5a2c4591&scoped=true"
import script from "./WorkCalendarEditDialog.vue?vue&type=script&lang=js"
export * from "./WorkCalendarEditDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarEditDialog.vue?vue&type=style&index=0&id=5a2c4591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c4591",
  null
  
)

export default component.exports